import { types as t } from 'mobx-state-tree';
import { AbstractQuestion } from './abstract-question.store';
import { KeyValueModel } from '../key-value.store';
import { CorrectOption } from './CorrectOption/correct-option.store';

export const AbstractQuestionWithMultipleOption = AbstractQuestion.named(
  'AbstractQuestionWithMultipleOption'
).props({
  correctOptions: t.array(t.maybeNull(CorrectOption)),
  maxSelectedOptions: t.maybeNull(t.number),
  options: t.array(KeyValueModel),
  question: t.maybeNull<any>(t.string),
  userAnswers: t.array(t.maybeNull(t.number)),
  notes: t.array(KeyValueModel),
});
